import { Button, Col, Form, InputNumber, App,Row, Input, DatePicker, Space,} from 'antd'
import React, { useRef, useState } from 'react'
import dayjs from 'dayjs';
import classes from '../expense.module.css'
import Main from '../../cpn/Main';
import PageTitle from '../../cpn/PageTitle';
import { useFeiyongAddMutation } from '../../store/NeiZhangFeiYongApi';
import ExpenseTypeSelect from '../type/ExpenseTypeSelect';
import UploadOne from '../../cpn/UploadOne';
import Uploadwx from '../../cpn/Uploadwx';
import { useNavigateWithTags } from '../../cpn/useNavigateWithTags';
const { TextArea } = Input;
function ExpenseAdd(props) {
    const editForm = useRef()
    const {message} = App.useApp();
    const e_id = JSON.parse(localStorage.getItem('e_id'));
    const eu_id = JSON.parse(localStorage.getItem('eu_id'));
    const eu_name = JSON.parse(localStorage.getItem('eu_name'));
    const [form] = Form.useForm();  
    const [info, setInfo] = useState({
        fy_content:'',
        fy_image:[],
        fy_date:dayjs().format('YYYY-MM-DD'),
        fy_month:dayjs().format('YYYY-MM'),
        fy_year:dayjs().format('YYYY'),
    });
    const [addBalance]= useFeiyongAddMutation();
    const navi = useNavigateWithTags() // 新增

    
    return (
        <Main>
            <PageTitle title='新增费用报销单' />
            <Row>
                <Col span={4}></Col>
                <Col span={16} className={classes.formAdd}>                   
                    <Form             
                        ref={editForm}                   
                        form={form}
                        style={{width: '100%' }}
                        layout="horizonal"
                        name="form_client"
                        initialValues={{
                            modifier: 'public',
                            fy_date:dayjs(),
                        }}
                        labelCol={{ span: 3}}                                    
                    >   
                        <ExpenseTypeSelect
                            label='报销类型'
                            name='fy_fyt_id'
                            onChange={(e,f) => { 
                                        setInfo(prevState=>({...prevState,fy_fyt_id:e,fy_fyt_name:f}))
                                    }}
                            eu_id={eu_id}
                            eu_name={eu_name}
                            e_id={e_id}
                            placeholder='请选择报销类型'
                            wrapperCol={{span:5}}
                        />
                        <Form.Item 
                            required 
                            name="fy_date" 
                            label='日期'
                        >                        
                            <DatePicker
                                onChange={(e) => {
                                    setInfo(prev => ({
                                        ...prev,
                                        fy_date:dayjs(e).format('YYYY-MM-DD'),
                                        fy_month:dayjs(e).format('YYYY-MM'),
                                        fy_year:dayjs(e).format('YYYY'),
                                    }))
                                }}
                            />
                        </Form.Item>                   
                                 
                        <Form.Item 
                            required 
                            name="fy_amount" 
                            label='金额'
                        >                        
                            <InputNumber
                                prefix={<>￥</>}  
                                onChange={(e) => {           
                                    const roundedValue = e !== null ? parseFloat(e.toFixed(2)) : null;                                     
                                    setInfo(prevState=>({...prevState,fy_amount:roundedValue}))
                                }}
                                min={0.01}
                                max='99999999.99'
                                precision={2}  // 强制显示两位小数
                                
                            />
                        </Form.Item>                                            
                        <Form.Item 
                            name='fy_content' 
                            label='备注'
                            wrapperCol={{span:10}}
                        >                        
                            <TextArea 
                                onChange={(e) => {
                                    setInfo(prevState=>({...prevState,fy_content:e.target.value}))
                                }}
                                rows={2}
                            />
                        </Form.Item>     
                        <UploadOne
                            fileStr={(e) => {
                                setInfo(prevsState=>({...prevsState,fy_image:e,}))}
                            }
                            name='fy_image'
                            style={{width:"100%"}} 
                            label='电脑传图'
                        />             
                        <Uploadwx
                            fileStr={(e) => {
                                setInfo(prevsState=>({...prevsState,fy_image:e,}))}
                            }
                        />         
                        <Form.Item wrapperCol={{offset:3}} >                        
                            <Space size={30}>
                                <Button 
                                    type='primary' 
                                    htmlType='submit'
                                    onClick={() => {
                                        addBalance({
                                            "fy_amount" : info.fy_amount,
                                            "fy_content" : info.fy_content,
                                            "fy_date" : info.fy_date,
                                            "fy_month" : info.fy_month,
                                            "fy_year" : info.fy_year,
                                            "fy_fyt_id" : info.fy_fyt_id,
                                            "fy_fyt_name" : info.fy_fyt_name,
                                            "fy_image" : info.fy_image,
                                            "fy_qy_id" : e_id,
                                            "fy_uid" : eu_id,
                                            "fy_uname" : eu_name,                              
                                        }).then((res) => {
                                            if (res.data.Status === 'success') {
                                                message.success('保存成功！')   
                                                form.resetFields();      
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('新增失败！'+res.data.Message)
                                            }
                                            
                                        })
                                    }}
                                >保存➔再增一条</Button>
                                <Button 
                                    type='primary' 
                                    htmlType='submit'
                                    onClick={() => {
                                        addBalance({
                                            "fy_amount" : info.fy_amount,
                                            "fy_content" : info.fy_content,
                                            "fy_date" : info.fy_date,
                                            "fy_month" : info.fy_month,
                                            "fy_year" : info.fy_year,
                                            "fy_fyt_id" : info.fy_fyt_id,
                                            "fy_fyt_name" : info.fy_fyt_name,
                                            "fy_image" : info.fy_image,
                                            "fy_qy_id" : e_id,
                                            "fy_uid" : eu_id,
                                            "fy_uname" : eu_name,                              
                                        }).then((res) => {
                                            if (res.data.Status === 'success') {
                                                message.success('保存成功！')   
                                                form.resetFields();      
                                                navi('/ExpenseList','费用列表'); // 新增：保存成功后跳转
                                            }
                                            if (res.data.Status === 'fail') {
                                                message.error('新增失败！'+res.data.Message)
                                            }
                                            
                                        })
                                    }}
                                >保存➔费用列表</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Col>
                <Col span={4}></Col>
            </Row>
            
        </Main>
    )
}

export default ExpenseAdd